/*
 * @Author: yaodongyi
 * @Date: 2022-05-31 11:57:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-15 12:26:43
 */
import axios from 'axios'
import { AxiosRequestConfig } from 'axios'
import { appBaseUrl } from '@/config'
import { globalWKLink } from './tools'

interface ConfigType {
  WX_APP_ID: string | any
  BASE_URL: string | any
  MAIN_URL: string | any
}

interface Iself {
  avatar_url: string
  id: number
  nickname: string
  role: string
  sex: string
  staff_name: string
  status: string
  subscribed: number
  telephone_validate: boolean
}

interface AccessType {
  account: Iself
  expiredAt: number
  id: number
  token: string
}

console.log(globalWKLink)

declare const window: any

let Config: ConfigType

if (location.hostname === 'dbg.weike.fm' || location.hostname === 'dbg.lizhiweike.com' || location.hostname === 'localhost') {
  Config = {
    WX_APP_ID: 'wx3502aeb0c3639966',
    BASE_URL: globalWKLink.main || 'https://dbg.lizhiweike.com',
    MAIN_URL: globalWKLink.wk || 'https://dbg.lizhiweike.com'
    // BASE_URL: appBaseUrl,
    // MAIN_URL: appBaseUrl
  }
} else {
  Config = {
    WX_APP_ID: 'wx3502aeb0c3639966',
    BASE_URL: globalWKLink.main || appBaseUrl,
    MAIN_URL: globalWKLink.wk || appBaseUrl
  }
}

export const PROD_URL = Config.BASE_URL

window.axios = axios

const RequestConfig = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
}

declare const Session: any

class Request {
  public async $get(url: string, options: AxiosRequestConfig) {
    const version = 'a'
    const randonNum = Math.random() * 100 + new Date().getTime()
    const Access: AccessType = await new Promise(resolve => Session.getToken(resolve))
    const token = Access.token
    const AllParams = { version, token, ...options.params, randonNum }
    let requestUrl = null
    if (url.indexOf('http') > -1) {
      requestUrl = url
    } else {
      requestUrl = Config.BASE_URL + url
    }
    return await axios.get(requestUrl, { ...options, params: AllParams })
  }

  public async $post(url: string, options: any, configOptions = {}) {
    const Access: AccessType = await new Promise(resolve => Session.getToken(resolve))
    const token = Access.token
    let requestUrl = null
    if (url.indexOf('http') > -1) {
      requestUrl = url
    } else {
      requestUrl = Config.BASE_URL + url
    }
    return await axios.post(requestUrl + '?token=' + token, options, { ...RequestConfig, ...configOptions })
  }
}

export default new Request()



// WEBPACK FOOTER //
// ./src/utils/request.ts